import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import { HeaderTableCellX } from 'framework/table/HeaderTableCellX';
import { NoContentTableHeadX } from 'framework/table/NoContentTableHeadX';
import { SortableHeaderTableCellX } from 'framework/table/SortableHeaderTableCellX';
import { ILoan, IQueryResult, ISortParams } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { LoanTableRow } from './LoanTableRow';

interface IProps {
	queryResult: IQueryResult<ILoan>;
	sortParams: ISortParams<ILoan>;
	onFilter: (sp: ISortParams<ILoan>) => void;
	expandedId: string | undefined;
	expandAll: boolean;
	toggle: (id: string) => void;
}

export const LoansTable = ({ queryResult, sortParams, onFilter, expandedId, expandAll, toggle }: IProps) => {
	const strings = useLocalization();

	return (
		<Table stickyHeader>
			{queryResult.unfilteredCount === 0 && <NoContentTableHeadX>{strings.noLoansRegisteredYet}</NoContentTableHeadX>}
			{queryResult.unfilteredCount > 0 && (
				<TableHead>
					<TableRow>
						<SortableHeaderTableCellX<ILoan>
							isFirst
							forProperty='reference'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.reference}
						</SortableHeaderTableCellX>
						<SortableHeaderTableCellX<ILoan>
							forProperty='startDate'
							sortParams={sortParams}
							onFilter={onFilter}>
							{strings.startDate}
						</SortableHeaderTableCellX>
						<HeaderTableCellX>{strings.patient}</HeaderTableCellX>
						<HeaderTableCellX isLast></HeaderTableCellX>
					</TableRow>
				</TableHead>
			)}
			<TableBody>
				{queryResult.values.map(t => (
					<LoanTableRow
						key={t.id}
						item={t}
						isExpanded={expandedId === t.id || expandAll}
						toggle={() => toggle(t.id)}
					/>
				))}
			</TableBody>
		</Table>
	);
};
